export const vsLookupManagementServiceName = "contractLookupManagementService";
export const vsLookupManagementServiceProviderName = `${vsLookupManagementServiceName}Provider`;
